import {
    listPrescription,
    addPrescription,
    updatePrescription,
    delPrescription,
    getPrescriptionDetail
} from "@/api";
import {message} from "../../utils/common";
import Medicinal from "@/components/medicinal.vue";

export default {
    components: {
        Medicinal
    },
    data() {
        return {
            userInfo: null,
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                docId: null,
                preName: null,
                billingType: null,
            },
            tableLoading: false,
            tableData: [],
            tableHeight: 500,
            indexMedicine: null,
            addDialogVisible: false,
            editDialogVisible: false,
            editPreId: "",
            preMedInfo: "",
            prescriptionInfo: {
                preName: "",
                instructions: "",
                docPrescriptionMedicineList: [],
                billingType: "0",
                isTop: '1'
            },
            medicineInfo: {
                medicineId: null,
                meName: null,
                price: null,
                gCount: null,
                newGCount: null,
                newRatio: null,
                standard: null,
                meRemark: null,
                mCount: null
            },
            medicinalChooseDrawer: false,
            direction: 'rtl',
            docMedicineArray: [],
            pagename: "prescription",
            newRuleOpen: false,
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        }, 500)
    },
    created() {
        this.newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.queryDocId = this.doctorInfo.doctorId;
            this.getlistPrescription();
        }
        this.medicineList = JSON.parse(window.sessionStorage.getItem("medicineList"));
        if (this.medicineList !== null && this.medicineList !== "") {
            this.getMedicineList();
        }
    },
    methods: {

        // 选择剂型
        changeMedicineType() {
            if (this.prescriptionInfo.billingType !== this.indexMedicine) {
                if (this.prescriptionInfo.docPrescriptionMedicineList.length > 0) {
                    this.$confirm('更换开方剂型将重置已选的药品, 是否继续?', '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(() => {
                        window.sessionStorage.removeItem('billingType');
                        window.sessionStorage.removeItem('medicineList');
                        this.indexMedicine = this.prescriptionInfo.billingType;
                        window.sessionStorage.setItem("billingType", this.prescriptionInfo.billingType);
                        console.log("this.indexMedicine");
                        console.log(this.prescriptionInfo.billingType);
                        this.prescriptionInfo.docPrescriptionMedicineList = [];
                        this.docMedicineArray = [];
                    }).catch(() => {
                        console.log('用户取消更换');
                        this.prescriptionInfo.billingType = this.indexMedicine;
                    })
                } else {
                    window.sessionStorage.removeItem('billingType');
                    window.sessionStorage.removeItem('medicineList');
                    window.sessionStorage.setItem("billingType", this.prescriptionInfo.billingType);
                    console.log(this.prescriptionInfo.billingType);
                    this.prescriptionInfo.docPrescriptionMedicineList = [];
                    this.docMedicineArray = [];
                }
            } else {
                window.sessionStorage.removeItem("billingType");
                window.sessionStorage.setItem("billingType", this.prescriptionInfo.billingType);
            }

        },

        // 获取药材信息
        getMedicineList() {
            this.docMedicineArray = [];
            console.log(this.medicineList)
            this.medicineList.forEach(melist => {
                if (melist.meName !== null && melist.meName !== undefined) {
                    console.log("melist value >>> " + melist.medicineId);
                    melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                    if (this.prescriptionInfo.billingType === "0") {
                        if (melist.newGCount === null) {
                            melist.newGCount = melist.gCount;
                        }
                        if (melist.newRatio === null) {
                            melist.newRatio = 1;
                        }
                        if (this.newRuleOpen) {
                            melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                        } else {
                            melist.gCount = melist.newGCount;
                        }
                    } else {
                        melist.newGCount = melist.gCount;
                    }
                    this.docMedicineArray.push({
                        medicineId: melist.medicineId,
                        meName: melist.meName,
                        price: melist.price,
                        gCount: melist.gCount,
                        newGCount: melist.newGCount,
                        newRatio: melist.newRatio,
                        standard: melist.standard,
                        meRemark: melist.meRemark,
                        mCount: melist.mCount,
                        decoctionId: melist.decoctionId,
                        decoctionName: melist.decoctionName,
                        drugProperty: melist.drugProperty
                    });
                }
            })
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            if (this.docMedicineArray.length > 0) {
                this.docMedicineArray.forEach(docMedlist => {
                    docMedlist.decoctWay = docMedlist.decoctionId;
                });
                this.prescriptionInfo.docPrescriptionMedicineList = this.docMedicineArray;
            }
        },


        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.preName = "";
            this.queryParams.pageNum = "";
            this.queryParams.pageSize = "";
            this.getlistPrescription();
        },


        // 切换分页
        handleCurrentChange: function (val) {
            this.currentPage = val;
            this.getlistPrescription();
        },

        // 切换分页
        handleSizeChange: function (val) {
            this.pageNums = val;
            this.getlistPrescription();
        },


        // 获取医生处方模版
        getlistPrescription() {
            this.tableData = [];
            this.tableLoading = true;
            this.queryParams.docId = parseInt(this.queryDocId);
            this.queryParams.pageNum = this.currentPage;
            this.queryParams.pageSize = this.pageNums;
            this.queryParams.reasonable = "false";
            listPrescription(this.queryParams).then(res => {
                const rdata = res.data;
                console.log(rdata);
                this.tableLoading = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;
                    this.tableData.forEach((item) => {
                        if (item.billingType === "0") {
                            item.billingTypeName = "颗粒";
                        } else if (item.billingType === "1") {
                            item.billingTypeName = "饮片";
                        } else if (item.billingType === "2") {
                            item.billingTypeName = "膏方";
                        } else if (item.billingType === "3") {
                            item.billingTypeName = "水丸";
                        }
                        let medInfo = "";
                        this.prescriptionInfo.docPrescriptionMedicineList = item.docPrescriptionMedicineList;
                        if (this.prescriptionInfo.docPrescriptionMedicineList.length > 0) {
                            this.prescriptionInfo.docPrescriptionMedicineList.forEach(item => {
                                item.meName = item.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                                medInfo += item.meName;
                                if (item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '') {
                                    medInfo += "(" + item.decoctionName + ")";
                                }
                                if (item.decoctWay !== null && item.decoctWay !== undefined && item.decoctWay !== '') {
                                    medInfo += "(" + item.decoctWay + ")";
                                }
                                if (item.billingType === "0") {
                                    if (item.newGCount === null) {
                                        item.newGCount = item.gCount;
                                    }
                                    if (this.newRuleOpen) {
                                        item.gCount = parseFloat(parseFloat(item.newGCount) * parseFloat(item.newRatio)).toFixed(2);
                                    } else {
                                        item.gCount = item.newGCount;
                                    }
                                } else {
                                    item.newGCount = item.gCount;
                                }
                                medInfo += "(" + item.newGCount + "g)" + ",";
                            })
                            medInfo = medInfo.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            item.preMedInfo = medInfo.substring(0, medInfo.length - 1);
                        }
                    })

                }
            }).catch(error => {
                message(error, "error");
            });
        },


        // 新增自建模版
        addNewPrescription() {
            this.pretype = "add";
            this.addDialogVisible = true;
            this.prescriptionInfo.preName = "";
            this.prescriptionInfo.instructions = "";
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            this.prescriptionInfo.billingType = "0";
            this.prescriptionInfo.isTop = "";
        },


        // 修改自建模版
        editNewPrescription(index, tdata) {
            this.editPreId = tdata[index].preId;
            console.log(tdata[index]);
            this.pretype = "edit";
            this.editDialogVisible = true;

            let billingType = tdata[index].billingType;
            this.prescriptionInfo.billingType = billingType;
            this.indexMedicine = billingType;
            window.sessionStorage.removeItem('billingType');
            window.sessionStorage.setItem('billingType', this.prescriptionInfo.billingType);
            this.docMedicineArray = [];
            this.medicineList = [];
            window.sessionStorage.removeItem('medicineList');
            this.getPrescriptionDetailInfo(this.editPreId);
        },


        // 查询模版详细信息
        getPrescriptionDetailInfo(preId) {
            console.log("getPrescriptionInfo choosePreId >>>>> " + preId);
            getPrescriptionDetail(preId).then(response => {
                // console.log(response);
                this.prescriptionInfo = response.data.data;
                // 解析处方模版详情
                let isTop = this.prescriptionInfo.isTop;
                if (isTop !== null && isTop !== "" && isTop !== undefined) {
                    if (isTop === '0') {
                        this.isSetTop = true;
                    } else {
                        this.isSetTop = false;
                    }
                } else {
                    this.isSetTop = false;
                }

                if (this.medicineList !== null && this.medicineList !== "" && this.medicineList.length > 0) {
                    this.docMedicineArray = [];
                    this.medicineList.forEach(melist => {
                        if (melist.meName !== null && melist.meName !== "" && melist.meName !== undefined) {
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            if (this.prescriptionInfo.billingType === "0") {
                                if (melist.newGCount === null) {
                                    melist.newGCount = melist.gCount;
                                }
                                if (this.newRuleOpen) {
                                    melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                                } else {
                                    melist.gCount = melist.newGCount;
                                }
                            } else {
                                melist.newGCount = melist.gCount;
                            }
                            let mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.price,
                                gCount: melist.gCount,
                                newGCount: melist.newGCount,
                                newRatio: melist.newRatio,
                                standard: melist.standard,
                                meRemark: melist.meRemark,
                                mCount: mCount,
                                decoctionId: melist.decoctionId,
                                decoctionName: melist.decoctionName,
                                drugProperty: melist.drugProperty
                            });
                        }

                    })
                }
                this.doMedicineList = this.prescriptionInfo.docPrescriptionMedicineList;
                // console.log(this.prescriptionInfo);
                this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中

            });
        },

        // 将处方模版的药品拼接到药品列表中
        docMedicineArrayPush() {
            console.log(this.doMedicineList);
            if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                this.doMedicineList.forEach((melist) => {
                    if (melist.meName !== null && melist.meName !== "" && melist.meName !== undefined) {
                        melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        if (this.prescriptionInfo.billingType === "0") {
                            if (melist.newGCount === null) {
                                melist.newGCount = melist.gCount;
                            }
                            if (this.newRuleOpen) {
                                melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                            } else {
                                melist.gCount = melist.newGCount;
                            }
                        } else {
                            melist.newGCount = melist.gCount;
                        }
                        let mCount;
                        if (melist.gCount === "" || melist.gCount === null || melist.gCount === undefined) {
                            mCount = parseFloat(parseFloat(0) * parseFloat(melist.price)).toFixed(2);
                        } else {
                            mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                        }
                        this.docMedicineArray.push({
                            changeMed: false,
                            focusMeName: false,
                            focusGcount: false,
                            medicineId: melist.medicineId,
                            meName: melist.meName,
                            price: melist.price,
                            gCount: melist.gCount,
                            newGCount: melist.newGCount,
                            newRatio: melist.newRatio,
                            standard: melist.standard,
                            meRemark: melist.meRemark,
                            mCount: mCount,
                            decoctionId: melist.decoctionId,
                            decoctionName: melist.decoctionName,
                            decoctWay: melist.decoctWay
                        });
                    }
                })
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
                this.prescriptionInfo.docPrescriptionMedicineList = [];
                this.prescriptionInfo.docPrescriptionMedicineList = this.docMedicineArray;
            }
        },


        // 确定修改常用处方
        editPrescriptionFun() {
            if (this.prescriptionInfo.preName === null || this.prescriptionInfo.preName === "" || this.prescriptionInfo.preName === undefined) {
                message("处方名称不能为空", "error");
            } else if (this.prescriptionInfo.docPrescriptionMedicineList.length <= 0) {
                message("处方药品不能为空", "error");
            } else {
                if (this.pretype === "add") {
                    addPrescription(this.prescriptionInfo).then(response => {
                        if (response.code === 200) {
                            message("新增成功", "success");
                            window.sessionStorage.removeItem('medicineList');
                            window.sessionStorage.removeItem('preId');
                            this.addDialogVisible = false;
                            this.getlistPrescription();
                        } else {
                            message("新增失败", "error");
                        }
                    });
                } else {
                    this.$confirm('确定要修改所选处方模版吗？', "温馨提示").then(() => {
                        updatePrescription(this.prescriptionInfo).then(response => {
                            if (response.code === 200) {
                                message("修改成功", "success");
                                window.sessionStorage.removeItem('medicineList');
                                window.sessionStorage.removeItem('preId');
                                this.editDialogVisible = false;
                                this.getlistPrescription();
                            } else {
                                message("修改失败", "error");
                            }
                        });
                    }).catch(() => {
                        console.log('用户取消');
                    })
                }
            }

        },

        // 取消修改常用处方
        cancelPrescriptionFun() {
            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.removeItem('preId');
            this.prescriptionInfo.preName = "";
            this.prescriptionInfo.instructions = "";
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            this.prescriptionInfo.billingType = "0";
            this.prescriptionInfo.isTop = "";
            if (this.pretype === "add") {
                this.addDialogVisible = false;
            } else if (this.pretype === "edit") {
                this.editDialogVisible = false;
            }
        },

        // 删除处方模版
        deletePrescription(index, tdata) {
            this.$confirm('确定要删除所选处方模版吗？', "温馨提示").then(() => {
                delPrescription(tdata[index].preId).then((response) => {
                    if (response.code === 200) {
                        message("删除成功", "success");
                        this.getlistPrescription();
                    } else {
                        message("删除失败", "error");
                    }
                })
            }).catch(() => {
                console.log('用户取消');
            })
        },

        // 批量删除处方模版
        multipleDeletePrescription() {
            const selectedRows = this.$refs.multipleTable.getSelectionRows();
            if (selectedRows.length <= 0) {
                message("请至少选择一个处方模版！", "error");
            } else {
                this.$confirm('确定要删除所选处方模版吗？', "温馨提示").then(() => {
                    let ids = selectedRows.map(item => item.preId)
                    delPrescription(ids).then((response) => {
                        if (response.code === 200) {
                            message("删除成功", "success");
                            this.getlistPrescription();
                        } else {
                            message("删除失败", "error");
                        }
                    })
                }).catch(() => {
                    console.log('用户取消');
                })
            }
        },


        // 选择药材
        openChooseMedicinalDrawer() {
            this.medicinalChooseDrawer = true;
            this.billingType = "颗粒";
        },

        // 选择药材弹窗关闭
        getMedicinalDrawerStatus() {
            this.medicinalChooseDrawer = false;
            this.medicineList = JSON.parse(window.sessionStorage.getItem("medicineList"));
            this.getMedicineList();
        },


    }
}